/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';

const inlineEdit = (linkKey, item, handler) => {
	return (
		<a href="javascript:void(0)"><span className="edit" onClick={() => handler(item)}>Edit</span></a>
	);
};

const inlineInactivate = (linkKey, item, handler) => {

	return (
		<a href="javascript:void(0)"><span className="delete" onClick={() => window.confirm(`Inactivate item ${item.name}?`) ? handler(item.id) : ""}>Inactivate</span></a>
	);

};

const inlineCancel = (handler) => {
	let emptyItem = {
		id: false,
		name: ""
	};
	return (
		<a href="javascript:void(0)"><span className="cancel" onClick={() => handler(emptyItem)}>Cancel</span></a>
	);
};

const inlineUpdate = (linkKey, item, handler) => {

	return (
		<a href="javascript:void(0)"><span className="update" onClick={() => handler()}>Update</span></a>
	);

};

const InlineLi = (props) => (

	< div >
		<ul className={props.liClass}>
			{
				props.items.length ?
					props.items.map((item, i) => {
						let nameFetch = props.nameKey ? item[props.nameKey] : item.name;
						return (
							<li key={i} name={nameFetch} className="liEdit">
								{
									props.editedState.id === item.id ?

										<div>
											<input className="nameEdit" type="text" value={props.editedState.name} onChange={props.handleInput} name="name" />
											{props.showDescript ?
												<input className="descriptEdit" type="text" value={props.editedState.description} onChange={props.handleInput} name="description" /> : ""

											}
											{props.showEditableCheckbox ?
												<div className="editableBox">
													<label >Editable:</label>
													<input className="isEditableCheckbox" type="checkbox" value={props.editedState.valueIsEditable} onChange={props.handleInput} name="valueIsEditable" checked={props.editedState.valueIsEditable} /></div> : ""
											}
											<div className="actions">
												{inlineCancel(props.editClick)}
												{inlineInactivate(props.linkKey, item, props.deleteClick)}
												{inlineUpdate(props.linkKey, item, props.updateClick)}
											</div>
										</div>
										:
										<div>
											<span className="mainDesc">{nameFetch}</span>
											<div className="actions">
												{inlineEdit(props.linkKey, item, props.editClick)}
											</div>
										</div>
								}



							</li>
						);
					})
					:
					<p>No Items</p>
			}

		</ul>
	</div >

);

InlineLi.propTypes = {
	editedState: PropTypes.object.isRequired,
	linkKey: PropTypes.string.isRequired,
	liClass: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	deleteClick: PropTypes.func.isRequired,
	editClick: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired
};

export default InlineLi;



// WEBPACK FOOTER //
// ./src/Components/InlineLi/index.js